import React from 'react';
import { Route, Switch } from 'react-router-dom';
import List from 'components/Applications/List';
import Application from 'components/Applications/Application'

export default class Applications extends React.Component {
  render = () => {
    const { match } = this.props;
    return (
      <div>
        <Switch>
          <Route exact path={match.url} component={List}/>
          <Route path={`${match.url}/:appNumber`} component={Application}/>
        </Switch>
      </div>
    );
  };
}



// WEBPACK FOOTER //
// ./src/components/Applications/index.js